import { Component } from '@angular/core';

@Component({
  selector: 'tf-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {}
